<template>
	<section>
		<div class="header">VERLOF AANVRAGEN</div>
		<form @submit.prevent="submitUserAvailability">
			<main>
				<div :class="multipleDays ? 'checked' : ''" class="line">
					<span>Meerdere dagen</span>
					<ToggleField :checked="multipleDays" @change="toggleMultipleDays"></ToggleField>
				</div>
				<div v-if="multipleDays === false" class="checked line">
					<span>Eén dag</span>
					<div class="date-group">
						<DateField v-model="startDate" key="singleStartDate" placeholder="Datum" :minimum-allowed-date="minDate"></DateField>
						<span v-if="errors.includes('start-date')" class="error">Vul een datum in</span>
					</div>
				</div>
				<div v-if="multipleDays === true" class="checked line">
					<div class="date-group">
						<DateField v-model="startDate" key="multipleStartDate" placeholder="Begindatum" :minimum-allowed-date="minDate"></DateField>
						<span v-if="errors.includes('start-date')" class="error">Vul een datum in</span>
					</div>
					<div class="date-group">
						<DateField v-model="endDate" key="multipleEndDate" placeholder="Einddatum" :minimum-allowed-date="minDate"></DateField>
						<span v-if="errors.includes('end-date')" class="error">Vul een datum in</span>
					</div>
				</div>
			</main>
			<div class="actions">
				<Button class="Button cancel" @click="$router.back()">ANNULEER</Button>
				<Button type="submit" class="Button submit">AANVRAGEN</Button>
			</div>
		</form>
	</section>
</template>

<script>
import Button from "../Button.vue";
import ToggleField from "../ToggleField.vue";
import DateField from "../DateField.vue";
import {client} from "../../store";
import {mapActions} from "vuex";

export default {
	name: "SubmitAvailabilityVerlof",
	components: {DateField, Button, ToggleField},

	data() {
		return {
			multipleDays: false,
			errors: [],
			startDate: '',
			endDate: '',
			minDate: null
		}
	},

	beforeMount() {
		// Min date for leave is 2 weeks from now
		let date = new Date();
		date.setDate(date.getDate() + 14);
		this.minDate = date;
	},

	methods: {
		...mapActions({
			setLoading: "map/setLoading",
			setIdle: "map/setIdle"
		}),

		submitUserAvailability() {
			if (this.startDate === '') {
				this.errors.push('start-date');
			} else {
				this.errors = this.errors.filter(error => error !== 'start-date');
			}

			if (this.multipleDays === true) {
				if (this.endDate === '') {
					this.errors.push('end-date');
				} else {
					this.errors = this.errors.filter(error => error !== 'end-date');
				}
			}

			if (this.errors.length > 0) {
				return;
			}

			client.query(`
				mutation($type: String, $date_from: String, $date_till: String) {
					createUserAvailability(type: $type, date_from: $date_from, date_till: $date_till)
				}
			`, {
				type: "verlof",
				date_from: this.startDate,
				date_till: this.endDate
			}).then(() => {
				this.setIdle();
				this.$notify({
					group: "app",
					title: "Verlof doorgegeven",
					type: "success",
					text: "Verlof is succesvol doorgegeven"
				});

				this.$router.push({name: 'home'});
			}).catch((error) => {
				this.setIdle();
				if (error.hasOwnProperty("rawError") && error.rawError.length > 0 && error.rawError[0].debugMessage === "user_availability already exists") {
					this.$notify({
						group: "app",
						title: "Verlof doorgeven mislukt",
						type: "error",
						text: "Je hebt voor deze datum al verlof doorgegeven"
					});
				} else {
					this.$notify({
						group: "app",
						title: "Verlof doorgeven mislukt",
						type: "error",
						text: "Er is iets misgegaan bij het doorgeven van het verlof"
					});
				}
			});
		},

		toggleMultipleDays() {
			this.multipleDays = !this.multipleDays;
			this.startDate = '';
			this.endDate = '';
		}
	}
}
</script>

<style lang="scss" scoped>
main {
	border-bottom: 2px solid #eee;
}

.header {
	width: 100%;
	background-color: #1aae9f;
	font-weight: bold;
	color: #FFFFFF;
	text-align: center;
	padding: 8px;
}

.line {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: 16px;
	padding: 12px 16px;

	span {
		align-self: center;

		&.question {
			font-weight: bold;
		}
	}

	a {
		padding: 8px 8px 4px 8px;
		background-color: #2c88d9;
		border-radius: 4px;
		color: #FFF;
	}

	.date-group {
		width: calc(50% - 8px);
	}
}

.checked.line {
	background-color: #e3e8ed;
}

.actions {
	display: flex;
	justify-content: space-between;

	Button {
		font-weight: bold;
		color: #FFFFFF;
		border-radius: 4px;
		margin: 16px;

		&.cancel {
			background-color: #d3455b;
		}
		&.submit {
			background-color: #1aae9f;
		}
	}
}

::v-deep .DateField {
	.DateField__group {
		.TextField {
			border: none;
			border-radius: 4px;
			background-color: #FFFFFF;
		}
	}
}

span.error {
	color: #d3455b;
}
</style>
